import React, { FC, VFC, useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import './PaymentCompletedModal.scss';
import { Order, Appointments, Pet } from '../types';
import Utils from '@/utils/util';

import BackIcon from '@/assets/img/back-icon.svg';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import CompletedIcon from '@/assets/img/v2/tick-icon.png';
import { RoomBooking } from '@/features/auth';
import { PetConfirmationDisplay } from './PetConfirmationDisplay';
import { LineItem } from '../api/updatePayment';

import { businessCurrency } from '@/features/Language/api/getCountryCurrency';
import { useParams } from 'react-router-dom';
import storage from '@/utils/storage';
type RequestPaymentProps = {
  open: boolean;
  onClose: (refresh: boolean) => void;
  id: string;
  orders?: Order[];
  selectedAppointment: Appointments;
  lineItem?: LineItem;
  onBackToList?: () => void;
  showDialogOnly?: boolean;
  roomBooking: any;
  businessLocation?: any;
  paymentProvider?: string;
};
const PaymentCompletedModal = ({
  open,
  onClose,
  orders,
  selectedAppointment,
  lineItem,
  onBackToList,
  showDialogOnly,
  roomBooking,
  businessLocation,
  paymentProvider,
}: RequestPaymentProps) => {
  const country = storage.getKey('country');
  const totalAmount: any =
    orders && orders.length > 0
      ? orders.reduce((sum, order) => sum + parseFloat(order?.paymentAmount), 0)
      : 0;
  const petParent = roomBooking ? roomBooking.petParent : selectedAppointment.petParent;
  const petData = roomBooking
    ? roomBooking.pets
      ? roomBooking.pets
      : roomBooking.pet
      ? [roomBooking.pet]
      : []
    : selectedAppointment.pet
    ? [selectedAppointment.pet]
    : [];
  
  const { t } = useTranslation();

  const getDetailedView = () => {
    return (
      <>
        <div className="details-div">
          <img src={CompletedIcon} className="completed-image" />
        </div>

        <div className="payment-amount">
        {businessCurrency(country,'USD')} {lineItem?.total ? lineItem?.total : totalAmount}
        </div>
        <div className="payment-message">Your payment has been done successfully</div>
        <span className="payment-seperator">
          <hr />
        </span>
        <div className="payment-details">
          <div className={`details-div mt-10`}>
            <div className="title">{t('Pet name')}</div>
            <div className="values">
              {petData.map((pet:any, index:number) => (
                <PetConfirmationDisplay data={pet} showPrice={false} />
              ))}
            </div>
          </div>
          {roomBooking?.room ? (
            roomBooking?.accomodationType === Utils.ACCOMODATION_TYPES.BOARDING ? (
              <>
                <div className="details-div">
                  <div className="title">{t('Service Detail')}</div>
                  <div className="values">
                    {t('Boarding Service')}<span className="value-seperator"></span>{' '}
                    <span className="value-light">
                      {parseInt(roomBooking?.duration) > 1 ? roomBooking?.duration + ' Days' : roomBooking?.duration + ' Day' }{' '}
                    </span>
                  </div>
                </div>
                <div className="details-div">
                  <div className="title">{t('Check-in date')}</div>
                  <div className="values">
                    {Utils.formatDateStringTz(
                      roomBooking?.startTime,
                      roomBooking?.businessLocation
                        ? roomBooking?.businessLocation?.timezone
                        : businessLocation?.timezone,
                      "DD MMM 'yy, HH:mm a "
                    )}
                  </div>
                </div>
                <div className="details-div">
                  <div className="title">{t('Check-out date')}</div>
                  <div className="values">
                    {Utils.formatDateStringTz(
                      roomBooking?.endTime,
                      roomBooking?.businessLocation
                        ? roomBooking?.businessLocation?.timezone
                        : businessLocation?.timezone,
                      "DD MMM 'yy, HH:mm a "
                    )}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="details-div">
                  <div className="title">{t('Service Details')}</div>
                  <div className="values">
                    {t('DayCare Service')} <span className="value-seperator"></span>{' '}
                    <span className="value-light">
                      {Utils.getDuration(parseFloat(roomBooking?.duration))}{' '}
                    </span>
                  </div>
                </div>
                <div className="details-div">
                  <div className="title">{t('Scheduled date')}</div>
                  <div className="values">{Utils.formatDateToString(roomBooking?.startTime)}</div>
                </div>
                <div className="details-div">
                  <div className="title">{t('Scheduled time')}</div>
                  <div className="values">
                    {Utils.getAMPMtimeWithoutFormat(roomBooking?.startTime)} -{' '}
                    {Utils.getAMPMtimeWithoutFormat(roomBooking?.endTime)}{' '}
                  </div>
                </div>
              </>
            )
          ) : (
            <>
              <div className="details-div">
                <div className="title">{t('Service booked')}</div>
                <div className="values">{selectedAppointment?.service?.name}</div>
              </div>
              <div className="details-div">
                <div className="title">{isMobile ? 'Provider' : 'Service provider'}</div>
                <div className="values">{selectedAppointment?.businessUser?.email}</div>
              </div>
              <div className="details-div">
                <div className="title">{t('Appointment date')}</div>
                <div className="values">
                  {Utils.formatDateToString(selectedAppointment?.startTime)}
                </div>
              </div>
              <div className="details-div">
                <div className="title">{t('Duration')}</div>
                <div className="values">
                  {Utils.getAMPMtimeWithoutFormat(selectedAppointment?.startTime)} -{' '}
                  {Utils.getAMPMtimeWithoutFormat(selectedAppointment?.endTime)}{' '}
                  <span className="value-seperator"></span>{' '}
                  <span className="value-light">
                    {selectedAppointment?.duration
                      ? Utils.getDuration(parseFloat(selectedAppointment?.duration))
                      : ''}{' '}
                  </span>
                </div>
              </div>
            </>
          )}

          <div className="details-div">
            <div className="title">{t('Ref number')}</div>
            <div className="values">{roomBooking ? roomBooking.id : selectedAppointment?.id}</div>
          </div>
          {lineItem?.serviceTip && lineItem?.serviceTip > 0 && <div className="details-div">
            <div className="title">Tip paid</div>
            <div className="values">
              +{businessCurrency(country,'USD')} {Utils.roundDecimal(lineItem?.serviceTip)}{' '}
            </div>
          </div>}
          <div className="details-div">
            <div className="title">{t('Payment method')}</div>
            <div className="values">{paymentProvider ? paymentProvider : '-'}</div>
          </div>
          <div className="details-div">
            <div className="title">{t('Sender name')}</div>
            <div className="values">{petParent?.name}</div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {isMobile && !showDialogOnly ? (
        <>
          {' '}
          <div className="back-nav-new" onClick={onBackToList}>
            <img src={BackIcon} alt="back icon" />
            <span>{t('Back')}</span>
          </div>
          <div className="scroll-45 payment-completed-modal">{getDetailedView()}</div>
        </>
      ) : (
        <Modal show={open} onHide={() => onClose(false)} className="payment-completed-modal">
          <Modal.Header closeButton></Modal.Header>

          <Modal.Body>{getDetailedView()}</Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default PaymentCompletedModal;
